import React from 'react';
import { MdInfo, MdClose } from 'react-icons/md';
import styled, { css } from 'styled-components/macro';

import { smallElevationShadow, uiColors } from '../../common/styles';
import FramiButton from '../common/FramiButton';
import FramiIconButton from '../common/FramiIconButton';

import { CheckIcon, InfoIcon, WarningIcon } from '../../icons';
import { useAppContext } from '../../context';

const Wrapper = styled.section`
    font-size: ${(props) => (props.$isMobile ? '12px' : '14px')};
    box-shadow: ${smallElevationShadow};
    border-radius: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: fit-content;
    transform: translateX(0);
    transition:
        transform,
        bottom 1s ease;
    pointer-events: auto;
    padding: ${(props) => (props.$hasButton ? (props.$isMobile ? '0 10px 0 6px' : '0 16px') : '5px 10px')};
    ${(props) => props.$variantStyle}
`;

const Text = styled.span`
    font-size: ${(props) => props?.$fontSize && `${props?.$fontSize}px`};
    font-weight: 300;
    padding: 2px 6px;
    text-align: center;

    @media (max-width: 450px) and (min-width: 0px) {
        font-size: ${(props) => !props?.$fontSize && '11px'};
    }
`;

const getTypeStyles = (variant) => {
    const styles = {
        info: {
            style: css`
                background-color: ${uiColors.GRAY_100};
                color: ${uiColors.GRAY_800};
            `,
            icon: <MdInfo size={18}/>,
        },
        success: {
            style: css`
                background-color: ${uiColors.GREEN_300};
                color: ${uiColors.PRIMARY_TEXT};
            `,
            icon: <CheckIcon />,
        },
        error: {
            style: css`
                background-color: ${uiColors.ERROR};
                color: ${uiColors.PRIMARY_0};
            `,
            icon: <WarningIcon />,
        },
        warning: {
            style: css`
                background-color: ${uiColors.WARNING};
                color: ${uiColors.PRIMARY_TEXT};
            `,
            icon: <InfoIcon />,
        },
        promo: {
            style: css`
                background-color: ${uiColors.PROMO};
                color: ${uiColors.WHITE};
            `,
            icon: <CheckIcon />,
        },
    };
    return styles[variant];
};

const CommunicationBar = ({
    type,
    text,
    leftIconOnClick,
    onClick,
    style,
    showButton,
    buttonTitle,
    buttonOnClick,
    fontSize,
}) => {
    const { isHandheldDevice } = useAppContext();

    const typeStyles = getTypeStyles(type);

    return (
        <Wrapper
            $variantStyle={typeStyles.style}
            $isMobile={isHandheldDevice}
            $hasButton={showButton}
            onClick={onClick}
            style={style}
        >
            <FramiIconButton
                style={{ cursor: leftIconOnClick ? 'pointer' : 'unset' }}
                title={`${type} button`}
                icon={
                    leftIconOnClick ? (
                        <MdClose size={18} opacity={0.6} onClick={leftIconOnClick} />
                    ) : (
                        typeStyles.icon
                    )
                }
                dataCy="close-hint"
            />
            <Text $fontSize={isHandheldDevice ? 12 : fontSize}>{text}</Text>
            {showButton && (
                <FramiButton
                    dataPh={`${type} bar button: ${buttonTitle}`}
                    additionalClassName={`${type}-btn`}
                    style={{
                        padding: '2px 8px',
                        fontSize: fontSize ?? (isHandheldDevice ? '11px' : '13px'),
                        lineHeight: isHandheldDevice ? '16px' : '22px',
                    }}
                    variant={type}
                    title={buttonTitle}
                    onClick={buttonOnClick}
                />
            )}
        </Wrapper>
    );
};

export default CommunicationBar;
